(() => {
  const GIFT_VARIANT_ID = 54977213989197;
  const GIFT_PRODUCT_ID = 10944146440525;

  let syncing = false;
  let timer = null;

  async function syncFreeGift() {
    if (syncing) return;
    syncing = true;

    try {
      const response = await fetch('/cart.js', {
        cache: 'no-store'
      });
      const cart = await response.json();

      const giftItem = cart.items.find(
        item => Number(item.product_id) === GIFT_PRODUCT_ID
      );

      const normalItems = cart.items.filter(
        item => Number(item.product_id) !== GIFT_PRODUCT_ID
      );

      // If there is a normal product, add one gift.
      if (normalItems.length > 0 && !giftItem) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: GIFT_VARIANT_ID,
              quantity: 1
            }]
          })
        });

        window.location.reload();
        return;
      }

      // Keep maximum one gift in the cart.
      if (giftItem && giftItem.quantity > 1) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: giftItem.key,
            quantity: 1
          })
        });

        window.location.reload();
        return;
      }

      // If no normal products remain, remove the gift.
      if (normalItems.length === 0 && giftItem) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: giftItem.key,
            quantity: 0
          })
        });

        window.location.reload();
      }

    } catch (error) {
      console.error('SoriGem free gift error:', error);
    } finally {
      syncing = false;
    }
  }

  function scheduleGiftCheck() {
    clearTimeout(timer);
    timer = setTimeout(syncFreeGift, 1500);
  }

  document.addEventListener('DOMContentLoaded', syncFreeGift);

  // Detect clicks and quantity changes in the cart drawer.
  document.addEventListener('click', scheduleGiftCheck, true);
  document.addEventListener('change', scheduleGiftCheck, true);

  // Detect Shopify AJAX cart requests.
  const originalFetch = window.fetch;

  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);

    const url =
      typeof args[0] === 'string'
        ? args[0]
        : args[0]?.url || '';

    if (
      url.includes('/cart/add') ||
      url.includes('/cart/change') ||
      url.includes('/cart/update') ||
      url.includes('/cart/clear')
    ) {
      scheduleGiftCheck();
    }

    return response;
  };
})();